import { Link } from 'react-router-dom';
import { MessageCircle, Mail, Clock } from 'lucide-react';

export default function Support() {
  return (
    <div className="min-h-full bg-white">
      {/* Header */}
      <header className="border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center gap-2">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
                <rect width="40" height="40" rx="10" fill="#36CCD8"/>
                <path d="M20 8L6 22L12 28L20 20L28 28L34 22L20 8Z" fill="white"/>
                <path d="M20 16L12 24L16 28L20 24L24 28L28 24L20 16Z" fill="white" fillOpacity="0.4"/>
              </svg>
              <span className="text-xl font-bold text-gray-900">Vecindus</span>
            </Link>
            <Link 
              to="/login" 
              className="px-4 py-2 text-[#36CCD8] font-semibold hover:text-[#2DB8C4] transition-colors"
            >
              Iniciar sesión
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Centro de Soporte</h1>
          <p className="text-lg text-gray-600">
            Estamos aquí para ayudarte. Elige la opción de contacto que prefieras.
          </p>
        </div>

        {/* Contact Options */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          <div className="bg-slate-50 rounded-2xl p-6 text-center">
            <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
              <MessageCircle className="w-7 h-7 text-blue-600" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Asistencia automática — 24/7</h3>
            <p className="text-sm text-gray-500 mb-4">
              Soporte disponible las 24 horas, los 7 días de la semana, mediante asistencia
              automatizada (agentes) dentro de la plataforma.
            </p>
            <button className="w-full py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors">
              Iniciar asistencia
            </button>
          </div>

          <div className="bg-slate-50 rounded-2xl p-6 text-center">
            <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-4">
              <Mail className="w-7 h-7 text-emerald-600" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Correo electrónico — escalaciones</h3>
            <p className="text-sm text-gray-500 mb-4">
              Para escalar un caso, envíanos un correo y te responderemos en menos de 24 horas
            </p>
            <a 
              href="mailto:info@vecindus.com" 
              className="inline-block w-full py-2 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors"
            >
              info@vecindus.com
            </a>
          </div>
        </div>


        {/* FAQ Section */}
        <div className="mb-12">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">Preguntas Frecuentes</h2>
          
          <div className="space-y-4">
            <details className="bg-slate-50 rounded-xl p-4">
              <summary className="font-medium text-gray-900 cursor-pointer">
                ¿Cómo registro una cuenta en Vecindus?
              </summary>
              <p className="text-gray-600 mt-2 pt-2 border-t border-slate-200">
                Haz clic en "Regístrate" en la página principal, ingresa tus datos y el código de tu condominio 
                para unirte a tu comunidad.
              </p>
            </details>

            <details className="bg-slate-50 rounded-xl p-4">
              <summary className="font-medium text-gray-900 cursor-pointer">
                ¿Cómo realizo el pago de mis cuotas?
              </summary>
              <p className="text-gray-600 mt-2 pt-2 border-t border-slate-200">
                Inicia sesión, ve a la sección de "Pagos" y selecciona el método de pago preferido. 
                Aceptamos tarjetas, transferencias y pago en efectivo en puntos de recolección.
              </p>
            </details>

            <details className="bg-slate-50 rounded-xl p-4">
              <summary className="font-medium text-gray-900 cursor-pointer">
                ¿Cómo registro a un visitante?
              </summary>
              <p className="text-gray-600 mt-2 pt-2 border-t border-slate-200">
                Desde la app o web, ve a "Visitantes" y registra los datos de tu visitante. 
                Recibirá un código QR para acceder el día de su visita.
              </p>
            </details>

            <details className="bg-slate-50 rounded-xl p-4">
              <summary className="font-medium text-gray-900 cursor-pointer">
                ¿Qué hago si olvidé mi contraseña?
              </summary>
              <p className="text-gray-600 mt-2 pt-2 border-t border-slate-200">
                Haz clic en "¿Olvidaste tu contraseña?" en la página de inicio de sesión e ingresa tu correo 
                electrónico para recibir un enlace de recuperación.
              </p>
            </details>
          </div>
        </div>

        {/* Hours */}
        <div className="bg-[#36CCD8]/5 rounded-2xl p-6 flex items-center gap-4">
          <Clock className="w-10 h-10 text-[#36CCD8] flex-shrink-0" />
          <div>
            <h3 className="font-semibold text-gray-900">Disponibilidad</h3>
            <p className="text-gray-600">
              Soporte disponible 24/7 mediante asistencia automatizada (agentes).<br />
              Escalaciones por correo a info@vecindus.com — respuesta en menos de 24 horas.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
